import { OuterStore as AvatarStore, update as avatars } from "./avatars";
import { OuterStore as Config, update as config } from "./config";
import { OuterStore as CreateForumModal, update as createForumModal } from "./createForumModal";
import { OuterStore as DebugLog, update as debugLog } from "./debugLog";
import { OuterStore as Dialpad, update as dialpad } from "./dialpad";
import {
    OuterStore as ElectronIntegration,
    update as electronIntegration,
} from "./electronIntegration";
import { OuterStore as Errors, update as errors } from "./errors";
import { OuterStore as History, update as history } from "./history";
import { OuterStore as Idle, update as idle } from "./idle";
import { OuterStore as JoinedRooms, update as joinedRooms } from "./joinedRooms";
import { OuterStore as MessageDropdown, update as messageDropdown } from "./messageDropdown";
import { OuterStore as Notifications, update as notifications } from "./notifications";
import { OuterStore as OAuth, update as oauth } from "./oauth";
import { OuterStore as Persist, update as persist } from "./persist";
import { OuterStore as Profile, update as profile } from "./profile";
import { OuterStore as RoomMeta, update as roomMeta } from "./roomMeta";
import { OuterStore as Rooms, update as rooms } from "./rooms";
import { OuterStore as Roster, update as roster } from "./roster";
import { OuterStore as RosterSearch, update as rosterSearch } from "./rosterSearch";
import { OuterStore as Uploads, update as uploads } from "./uploads";

export const reducers = {
    persist,
    errors,
    roster,
    avatars,
    idle,
    config,
    dialpad,
    history,
    notifications,
    rooms,
    joinedRooms,
    debugLog,
    uploads,
    rosterSearch,
    oauth,
    roomMeta,
    messageDropdown,
    profile,
    createForumModal,
    electronIntegration,
};

export type RootState = AvatarStore &
    Idle &
    Errors &
    Roster &
    Config &
    Dialpad &
    Persist &
    Notifications &
    Rooms &
    JoinedRooms &
    DebugLog &
    Uploads &
    RosterSearch &
    OAuth &
    RoomMeta &
    MessageDropdown &
    History &
    CreateForumModal &
    ElectronIntegration &
    Profile;
export type InitialState = Persist;
